import requestor from "shared/service/requestor";

export default class GroupApi {
  all = (courseId = null) => requestor.get("/course/group_all", { course_id: courseId });
  create = (courseId, form) => requestor.post("/course/group_create", { course_id: courseId, ...form });
  save = (courseId, form) => requestor.patch("/course/group_save", { course_id: courseId, Group: form });
  delete = (courseId, id) => requestor.delete("/course/group_delete", { course_id: courseId, id: id });
}
